import { BankAccountExportSelection } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/BankAccounts/bankAccountsExport.types.ts';
import { createBulkActions } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/BankAccounts/components/createBulkActions.ts';
import { useBankAccountsTable } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/BankAccounts/components/useBankAccountsTable.tsx';
import { MantineTable } from '@dealstack/frontend/shared/components/Table/MantineTable/MantineTable.tsx';
import { makeComplexDataTestId, TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';
import { MantineTableDataOperations } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableDataOperationsFromUrlParamState';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import {
	DataMipInvestorBankAccountRes,
	InvestorBankAccountsStatsRes,
} from '@dealstack/shared/lib/generated';
import { Flex } from '@mantine/core';

interface Props {
	bankAccounts?: DataMipInvestorBankAccountRes[];
	stats?: InvestorBankAccountsStatsRes;
	dataOperations: MantineTableDataOperations;
	isLoading?: boolean;
	onDownload: (selection: BankAccountExportSelection) => void;
	onRowClick: (bankAccountId: string) => void;
	isDownloading?: boolean;
}

export const Table = ({
	bankAccounts = [],
	stats,
	dataOperations,
	isLoading = false,
	onDownload,
	onRowClick,
	isDownloading = false,
}: Props) => {
	const tMipManage = useTranslationMipManage();
	const { columns } = useBankAccountsTable({ stats });

	return (
		<Flex w="100%" style={{ overflow: 'hidden' }}>
			<MantineTable<DataMipInvestorBankAccountRes>
				getRowId={(row) => row.id}
				columns={columns}
				data={bankAccounts}
				dataOperations={dataOperations}
				isLoading={isLoading}
				renderBulkActionsMenu={true}
				actions={(table) =>
					createBulkActions({
						table,
						isDownloading,
						tMipManage,
						onDownload,
					})
				}
				enableSearchBar={true}
				enableFilters={true}
				enablePagination={true}
				enableColumnResizing={true}
				pinnedColumnIds={['accountHolder']}
				// Filtering, sorting and paging run in SQL; the table renders one page.
				manualPagination={true}
				manualFiltering={true}
				manualSorting={true}
				rowCount={stats?.total ?? 0}
				enableRowSelection={true}
				enableRowActions={false}
				enableHiding={true}
				enableTopToolbar={true}
				enableStickyHeader={true}
				enableStickyFooter={true}
				hideFooterRows={false}
				enableVerticalCellBorders={false}
				footerCellMinHeight="56px"
				footerCellAlignTop={true}
				mantineTableBodyRowProps={({ row }) => ({
					onClick: () => onRowClick(row.original.id),
					'data-testid': makeComplexDataTestId(
						TEST_ELEMENT_IDS.MIP_MANAGE_BANK_ACCOUNT_ROW,
						row.original.id
					),
					style: { height: 'unset', cursor: 'pointer' },
				})}
			/>
		</Flex>
	);
};
